import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';

import { DailyStateOverviewModule } from '../daily-state-overview/daily-state-overview.module';
import { FlowChartModule } from '../flow-chart/flow-chart.module';
import { BlockTitleComponent } from '../components/block-title/block-title.component';
import { RtOverlayComponent } from './rt-overlay.component';

@NgModule({
  declarations: [RtOverlayComponent],
  imports: [
    CommonModule,
    BlockTitleComponent,
    DailyStateOverviewModule,
    FlowChartModule,
    IonicModule,
  ],
  exports: [RtOverlayComponent],
})
export class RtOverlayModule {}
